import { useAuth0 } from "@auth0/auth0-react";
import { Box, createStyles, Text } from "@mantine/core";
import React from "react";
import LoginCard from "../components/LoginCard";
import LoginPageWrapper from "../components/LoginPageWrapper";
import DowntimeBanner from "../../../common/elements/DowntimeBanner";

const useStyles = createStyles((theme) => ({
  infoBox: {
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    "@media (max-height: 800px)": {
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
    },
  },
}));

const Auth0LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const { classes } = useStyles();

  const handleLogin = (): void => {
    loginWithRedirect();
  };

  const handleCreatePassword = (): void => {
    loginWithRedirect(); // Both buttons are designed to redirect to same page simply to guide users through this unexpected flow
  };

  return (
    <>
      <DowntimeBanner />
      <LoginPageWrapper>
        <LoginCard>
          <LoginCard.Logo />
          <LoginCard.Title>Welcome Back!</LoginCard.Title>

          <LoginCard.SubTitle>New here?</LoginCard.SubTitle>

          <LoginCard.Instructions
            description="We've upgraded login for stronger security."
            items={[
              "Create your new email password",
              "Use your email and SMS OTP to log into the dashboard",
            ]}
          />

          <Box className={classes.infoBox}>
            <Text
              weight={700}
              align="center"
              color="#062133"
              mb="sm"
              style={{
                fontSize: "18px",
                fontFamily: "Inter, sans-serif",
                fontWeight: "bold",
              }}
            >
              Already set up? Continue to log in with your email and password.
            </Text>
          </Box>

          <LoginCard.PrimaryButton onClick={handleLogin}>
            Log In
          </LoginCard.PrimaryButton>

          <LoginCard.SecondaryButton onClick={handleCreatePassword}>
            Create New Password
          </LoginCard.SecondaryButton>
        </LoginCard>
      </LoginPageWrapper>
    </>
  );
};

export default Auth0LoginPage;
